<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: "sm" | "md";
  }>(),
  {
    size: "md",
  }
);
</script>

<template>
  <div class="loading-ring" :class="`loading-ring--${size}`">
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<style>
.loading-ring,
.loading-ring div {
  box-sizing: border-box;
}

.loading-ring {
  display: inline-block;
  position: relative;
}

.loading-ring--md {
  width: 40px;
  height: 40px;
}

.loading-ring--md div {
  width: 32px;
  height: 32px;
  margin: 4px;
  border-width: 4px;
}

.loading-ring--sm {
  width: 24px;
  height: 24px;
}

.loading-ring--sm div {
  width: 18px;
  height: 18px;
  margin: 2px;
  border-width: 2px;
}

.loading-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  border-style: solid;
  border-radius: 50%;
  animation: loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
}

.loading-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.loading-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.loading-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes loading-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
